import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Box, Button, Checkbox,
    Dialog, DialogActions, DialogContent, DialogTitle,
    FormControl, FormControlLabel, FormGroup,
    Typography
} from "@mui/material";

import { DataTypes } from "../../../../constants";
import rmsActions from "../../../../actions/rmsActions";
import { getCategories, getRmsAppCode, isFetching } from "../../../../reducers";


function ActivityCategoryFormDialog({open, formTitle, categories, checked, handleChange, onClose, onSubmit, ...props}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={true}
            maxWidth="md"
            {...props}
        >
            <DialogTitle>{formTitle}</DialogTitle>
            <DialogContent dividers={false}>
                <Box
                    component="form"
                    autoComplete="off"
                    noValidate
                    className="dialog-content"
                    onSubmit={(e) => e.preventDefault()}
                >
                    {!categories?.length
                        ? null
                        : categories
                            .filter(({id}) => !!id)
                            .map((data) => (
                                <Box
                                    component="div"
                                    className="form-row"
                                    key={data.id}
                                >
                                    <FormControl component="div" fullWidth={true}>
                                        <Typography variant="h3" component="h3" mb={2} >
                                            {data.name}
                                        </Typography>
                                        <CategoryListChildren
                                            categories={data.children}
                                            handleChange={handleChange}
                                            checked={checked}
                                        />
                                    </FormControl>
                                </Box>
                            ))
                    }
                </Box>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    key="save"
                    onClick={onSubmit}
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                >
                    Link
                </Button>
            </DialogActions>
        </Dialog>
    );
}


function ActivityCategoryFormDialogContainer({formTitle, onSave, onClose, data = [],  ...props}) {
    const dispatch = useDispatch();

    const appCode = useSelector(getRmsAppCode);
    const fetching = useSelector((state) => isFetching(state, DataTypes.CATEGORIES));
    let categories = useSelector(getCategories);

    if (!fetching && categories === null) {
        dispatch(rmsActions.getCategories(appCode));
        categories = [];
    }

    const getSelected = (cats) => cats.reduce((acc, curr) => (
        !curr.children?.length
            ? [...acc, Number(curr.id)]
            : [...acc, ...getSelected(curr.children)]
    ), []);
    const selected = getSelected(data);
    const [checked, setChecked] = useState(selected);

    const handleChange = (id, selected) => {
        setChecked(selected ? [...checked, id] : checked.filter((cat) => cat !== id));
    };
    const handleClose = () => {
        setChecked(selected);
        onClose();
    };
    const onSubmit = () => {
        const buildCatTree = (cats) => cats
            .filter((cat) => !cat.children?.length ? checked.includes(Number(cat.id)) : !!buildCatTree(cat.children).length)
            .map((cat) => ({...cat, children: !cat.children?.length ? null : buildCatTree(cat.children)}));
        onSave(buildCatTree(categories));
        onClose();
    };

    return (
        <ActivityCategoryFormDialog
            formTitle={formTitle}
            categories={categories}
            checked={checked}
            handleChange={handleChange}
            onClose={handleClose}
            onSubmit={onSubmit}
            {...props}
        />
    );
}


function CategoryListChildren({ categories, handleChange, checked }) {
    if (!categories?.length) { return null; }

    return (
        !categories[0].children
            ? (
                <FormGroup>
                    {categories.map((row) => (
                        <FormControlLabel
                            key={row.id}
                            control={
                                <Checkbox
                                    checked={checked.includes(Number(row.id))}
                                    onChange={({ target }) => handleChange(Number(row.id), target.checked)}
                                    name={row.name}
                                />
                            }
                            label={row.name}
                        />
                    ))}
                </FormGroup>
            )
            : (categories.map((row) => (
                <div>
                    <Typography variant="h4" component="h4" mb={2} >{row.name}</Typography>
                    <CategoryListChildren categories={row.children} handleChange={handleChange} checked={checked}/>
                </div>
            )))
    );
}


export default ActivityCategoryFormDialogContainer;
